import { REMOVE_API_ERROR } from './constants';

export const removeAPIError = () => ({
  type: REMOVE_API_ERROR
});
